export const envibuddy = {
    faqs: [
        { question: "How to apply for leave?"},
         { question: "What are the health benefits?"},
         { question: " How to update my personal information?"},
         { question: "What is the policy for working from home?"},
      ],
    // Add other company-specific contents here
    // For example: policies, guidelines, resources, etc.
    policies: [
      // ...policy objects
    ],
    guidelines: [
      // ...guideline objects
    ],
    // etc.
  };